
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[broadcastId]/bag",
      function () {
        return require("private-next-pages/live/[broadcastId]/bag.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[broadcastId]/bag"])
      });
    }
  